import * as Yup from 'yup';

export const initialValues = {
    objectiveAndResponseStrategy: [
        { title: 'Resolución en Primer Contacto', description: '' },
        { title: 'Tasa de Exactitud', description: '' },
        { title: 'Tiempo de Respuesta', description: '' },
    ],
};

export const validationSchema = Yup.object().shape({
    objectiveAndResponseStrategy: Yup.array().of(
        Yup.object().shape({
            title: Yup.string().required('Requerido'),
            description: Yup.string().required('Requerido'),
        })
    ),
});
